export const applicationHero = {
  title: '応募資格・申込の流れ',
  titleEn: 'REQUIREMENTS & STEPS',
  lead: '日本執事アカデミーへの応募資格と、お申込みから受講確定までの手続きの流れをご案内します。',
};

export const requirements = [
  {
    label: '年齢',
    value: '18歳以上（高校生はご応募いただけません）',
    icon: 'ri-user-line',
  },
  {
    label: '国籍・性別・経験',
    value: '国籍、性別、経験を問いません。未経験者を歓迎します。',
    icon: 'ri-global-line',
  },
  {
    label: '言語',
    value: '授業は日本語で行います。日本語での受講に支障がないこと。',
    icon: 'ri-chat-1-line',
  },
  {
    label: '身体的条件',
    value: '立ち仕事を含む実技実習に支障なくご参加いただけること。',
    icon: 'ri-heart-pulse-line',
  },
  {
    label: '規約同意',
    value: '受講規約および服装規定にご同意いただけること。',
    icon: 'ri-file-text-line',
  },
];

export const dressCode = {
  title: '授業時の服装規定',
  titleEn: 'Dress Code',
  lead: '授業中の服装は、執事としての所作を体得するうえで重要な要素です。初回授業時に詳細をご案内します。白手袋はアカデミーより初日にお渡しします。',
  items: [
    {
      name: '白シャツ',
      description: '無地の白シャツ（長袖を推奨）。清潔感のある、よく整えられたものをお持ちください。',
      icon: 'ri-shirt-line',
    },
    {
      name: '黒系スラックス または スカート',
      description: '黒またはチャコールグレーを基調とした、シルエットの美しいスラックスまたはスカート。',
      icon: 'ri-body-scan-line',
    },
    {
      name: '革靴',
      description: '黒の革靴（紐靴またはローファー）。長時間の実習に対応できる安定感のあるものを。',
      icon: 'ri-footprint-line',
    },
    {
      name: '白手袋（支給）',
      description: '高品質な白手袋を初日に支給します。実習中は常時着用していただきます。',
      icon: 'ri-hand-sanitizer-line',
    },
  ],
  imageAlt: '授業時の服装：白シャツ・黒スラックス・白手袋を着用した研修生',
};

export const applicationSteps = [
  {
    step: '01',
    title: '資料請求',
    titleEn: 'Request Brochure',
    description: 'まずは無料の資料請求から。コースの詳細やアカデミーの理念をまとめた資料をお届けします。',
    icon: 'ri-file-text-line',
    required: false,
  },
  {
    step: '02',
    title: '個別相談',
    titleEn: 'Consultation',
    description: '経験豊富なスタッフが、ご目標やご経験に合わせた最適なコース選びをサポートします。オンラインでも承ります。',
    icon: 'ri-chat-3-line',
    required: false,
  },
  {
    step: '03',
    title: '申込フォーム送信',
    titleEn: 'Submit Application',
    description: 'コースをお決めいただきましたら、所定の申込フォームより必要事項をご入力のうえ送信してください。',
    icon: 'ri-edit-box-line',
    required: true,
    instruction: '申込フォームへお進みください',
  },
  {
    step: '04',
    title: '受講契約のご案内',
    titleEn: 'Enrollment Contract',
    description: 'お申込み後、受講契約のご案内をメールにてお送りします。内容をよくご確認のうえ、ご契約手続きをお願いします。',
    icon: 'ri-mail-line',
    required: true,
    instruction: 'メールをご確認ください',
  },
  {
    step: '05',
    title: '受講料のお振込み',
    titleEn: 'Bank Transfer',
    description: '銀行振込（一括払いのみ）にて、開校14日前までに受講料をお振込みください。分割払い・クレジットカードはご利用いただけません。',
    icon: 'ri-bank-line',
    required: true,
    instruction: '開校14日前までにお振込みください',
  },
  {
    step: '06',
    title: '受講確定通知',
    titleEn: 'Confirmation',
    description: 'お振込みの確認後、受講確定通知とともにお持ち物・初回授業の詳細・アクセス案内をお送りします。',
    icon: 'ri-check-double-line',
    required: true,
    instruction: '通知をお待ちください',
  },
  {
    step: '07',
    title: '開校',
    titleEn: 'Course Begins',
    description: 'いよいよ開校です。初日はオリエンテーションと実習の基礎から、丁寧にスタートします。',
    icon: 'ri-play-circle-line',
    required: true,
  },
];

export const deadlineInfo = {
  title: '申込締切・定員',
  titleEn: 'Deadlines & Capacity',
  lead: '各コースとも、先着順での受付となります。定員に達し次第、締め切らせていただきますので、ご検討中の方はお早めにお申込みください。',
  items: [
    {
      label: '定員',
      value: '各コース 6名（先着順）',
      icon: 'ri-group-line',
    },
    {
      label: '申込締切',
      value: '各開校日の14日前まで',
      icon: 'ri-calendar-check-line',
    },
    {
      label: '最少催行人数',
      value: '3名',
      icon: 'ri-team-line',
    },
    {
      label: '未達時の対応',
      value: '最少催行人数（3名）に満たない場合、受講料を全額返金、または次期開校への振替時に受講料を5%優待いたします。',
      icon: 'ri-refund-2-line',
    },
  ],
};

export const paymentInfo = {
  title: 'お支払いについて',
  titleEn: 'Payment Details',
  lead: '受講料のお支払いは、銀行振込による一括払いのみとなります。お手続きの詳細は受講契約のご案内にてお知らせします。',
  items: [
    {
      label: 'お支払い方法',
      value: '銀行振込（一括払いのみ）。分割払い・クレジットカードはご利用いただけません。',
      icon: 'ri-bank-card-line',
    },
    {
      label: 'お支払い期限',
      value: '開校日の14日前までにお振込みください。',
      icon: 'ri-timer-line',
    },
    {
      label: '振込手数料',
      value: 'お客様ご負担にてお願いいたします。',
      icon: 'ri-money-dollar-circle-line',
    },
    {
      label: '編入優遇',
      value: '下位コース修了者は、お申込み時に修了証番号を申告いただくと編入優遇が適用されます。',
      icon: 'ri-vip-crown-line',
    },
  ],
};

export const applicationFaqs = [
  {
    question: '応募資格はありますか?',
    answer: '18歳以上で、日本語の授業と実技実習に支障がない方なら、国籍・性別・経験を問わず応募いただけます。',
  },
  {
    question: '申込はどう進めますか?',
    answer: '申込フォームのご提出後、受講契約のご案内をメールでお送りします。受講料のお振込み確認後に受講確定となります。',
  },
  {
    question: '締切はいつですか?',
    answer: '各開校日の14日前までです。定員6名に達した時点で締め切ります。',
  },
];

export const applicationRelatedPages = [
  {
    title: '申込フォーム',
    description: '本科コースのお申込み',
    href: '/apply',
  },
  {
    title: '個別相談予約',
    description: '無料・オンライン可の相談',
    href: '/consultation',
  },
  {
    title: '入学案内概要',
    description: '入学の流れと応募資格',
    href: '/admission',
  },
  {
    title: '年間スケジュール',
    description: '開校時期と授業日程',
    href: '/schedule',
  },
];